import React, { Fragment, useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import { useHistory } from "react-router-dom";
import MaterialTable, { MTableToolbar } from "material-table";
import { Button, CircularProgress, IconButton } from "@mui/material";
import {
  AddCircleOutline as AddCircleOutlineIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Cancel,
  Delete,
  Category,
  DeleteForever,
} from "@mui/icons-material";

import PopUpModel from "components/Popup/PopUpModel";
import TemporaryDrawer from "components/TemporaryDrawer";
import SkeletonLoader from "components/Loader/SkeletonLoader";
import NotFoundComponent from "components/NotFoundComponent";
import noFoundImg from "../../assets/img/no-data-found.jpg";
import { DeskTopContainer } from "themes/Device";
import { MobileContainer } from "themes/Device";
import MobileTitle from "components/MobileTitle";
import SearchBarInput from "components/SearchBarInput";
import MobileCategory from "components/MobileCategory";
import { RESOURCE } from "common/constant";
import { ACTION } from "common/constant";
import RoleBasedGuard from "guards/RoleBasedGuard";
//context
import {
  useLayoutState,
  useLayoutDispatch,
  addCurrentScreenTitle,
} from "context/LayoutContext";
import AddEditExpenseCategory from "./AddEditExpenseCategory";
import {
  useDeleteExpenseCategoryMutation,
  useExpenseCategory,
  useBulkDeleteExpenseCategoryClassMutation
} from "hooks/react-query/useExpenseCategory";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import CheckPermission from "./../../guards/CheckPermission";

const PREFIX = 'ExpenseCategoryList';

const classes = {
  cardCategoryWhite: `${PREFIX}-cardCategoryWhite`,
  cardTitleWhite: `${PREFIX}-cardTitleWhite`,
  root: `${PREFIX}-root`,
  tabel: `${PREFIX}-tabel`,
  prioritybtn: `${PREFIX}-prioritybtn`,
  mobileCard: `${PREFIX}-mobileCard`,
  mobileCategoryCard: `${PREFIX}-mobileCategoryCard`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.cardCategoryWhite}`]: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },

  [`& .${classes.cardTitleWhite}`]: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontFamily: '"Oxygen", sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },

  [`& .${classes.root}`]: {
    width: "100%",
  },

  [`& .${classes.tabel}`]: {
    margin: "10px",
    marginTop: "0",
    "& .MuiPaper-root": {
      padding: 10,
      paddingBottom: 0
    },
    "& tr": {
      height: 50,
      "& .MuiTableCell-root": {
        paddingLeft: "15px",
        fontSize: "14px !important",
      },
    },
  },

  [`& .${classes.prioritybtn}`]: {
    "& a:hover,& a:focus": {
      backgroundColor: "#FF5C93",
    },
    marginLeft: "5px",
    backgroundColor: "#FF5C93",
    color: "white",
  },

  [`& .${classes.mobileCard}`]: {
    padding: "2px",
    paddingBottom: '80px'
  },

  [`& .${classes.mobileCategoryCard}`]: {
    margin: '0 auto'
  }
}));

const ExpenseCategoryList = () => {
  const theme = useTheme();

  const { data: expenseCategoryDataList, loading: expenseCategoryLoader } =
    useExpenseCategory();
  const { mutate: deleteExpenseCategory } = useDeleteExpenseCategoryMutation();
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteExpenseCategoryId, setDeleteExpenseCategoryId] = useState(0);
  const [deletingBtnProcess, setDeletingBtnProcess] = useState(false);
  const [addEditDrawerShow, setAddEditDrawerShow] = useState(false);
  const [addEditExpenseCategoryId, setAddEditExpenseCategoryId] = useState(0);
  const [searchExpenseCategory, setSearchExpenseCategory] = useState("");
  const [filterExpenseCategoryList, setFilterExpenseCategoryList] = useState(
    [],
  );

  const history = useHistory();
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (layoutState?.currentScreenTitle !== "Expense Category") {
      addCurrentScreenTitle(layoutDispatch, {
        currentScreenTitle: t("expense-category-title"),
      });
    }
    return () => {
      if (layoutState?.currentScreenTitle === "Expense Category") {
        addCurrentScreenTitle(layoutDispatch, { currentScreenTitle: "" });
      }
    };
  }, []);

  const deleteFoodCategoryData = (foodCategoryId) => {
    if (foodCategoryId > 0) {
      setDeletingBtnProcess(true);
      deleteExpenseCategory(foodCategoryId);
      setDeletingBtnProcess(false);
      setDeleteModalShow(false);
    }
  };

  const addEditDrawerClose = () => {
    setAddEditDrawerShow(false);
    setAddEditExpenseCategoryId(0);
  };

  const deleteData = (deleteid) => {
    setDeleteExpenseCategoryId(deleteid);
    setDeleteModalShow(true);
  };
  const editData = (editid) => {
    history.push({
      pathname: `/app/expense-category/edit/${editid}`,
      state: {
        foodCategoryId: editid,
        backToMain: () => history.push(`/app/expense-category`),
      },
    });
  };
  const addDrawerShow = () => {
    history.push({
      pathname: `/app/expense-category/add`,
      state: {
        foodCategoryId: 0,
        backToMain: () => history.push(`/app/expense-category`),
      },
    });
  };

  const clearTxt = () => {
    setSearchExpenseCategory("");
  };

  useEffect(() => {
    setFilterExpenseCategoryList(expenseCategoryDataList);
  }, [expenseCategoryDataList]);

  useEffect(() => {
    if (searchExpenseCategory) {
      let filterCategoryList = expenseCategoryDataList?.filter(
        (item) =>
          item.name &&
          item.name
            ?.toLowerCase()
            ?.includes(searchExpenseCategory.toLowerCase()),
      );
      setFilterExpenseCategoryList(filterCategoryList);
    } else {
      setFilterExpenseCategoryList(expenseCategoryDataList);
    }
  }, [searchExpenseCategory]);

  const { mutate: deleteBulkExpenseCategory } = useBulkDeleteExpenseCategoryClassMutation();
  const [bulkDeleteIds, setbulkDeleteIds] = useState([]);
  const [deletebulkPopupshow, setDeletebulkPopupshow] = useState(false);
  const handleDeleteRows = async () => {
    setDeletebulkPopupshow(false)
    setbulkDeleteIds([]);
    deleteBulkExpenseCategory({
      variables: {
        input: {
          ids: bulkDeleteIds
        },
      },
    });
  };
  const handleDeleteRowsConformation = async (event, rowData) => {
    const ids = rowData.map((d) => d.id);
    setDeletebulkPopupshow(true)
    setbulkDeleteIds(ids);
  };
  return (
    <Root>
      <DeskTopContainer>
        <div className={classes.tabel}>
          <MaterialTable
            title={
              <h5>
                <b className="ml-3">{t("expense-category-title")}</b>
              </h5>
            }
            columns={[
              {
                title: t("expense-category-name-label"),
                field: "name",
                cellStyle: {
                  width: "45%",
                },
              },
              {
                title: t("description-label"),
                field: "description",
                cellStyle: {
                  width: "45%",
                },
              },
              {
                title: t("action"),
                field: "action",
                cellStyle: {
                  width: "10%",
                },
                render: (rowData) => (
                  <Fragment>
                    <RoleBasedGuard
                      resource={RESOURCE.EXPENSECATEGORY}
                      action={ACTION.UPDATE}
                    >
                      <IconButton
                        color="primary"
                        title={t("expense-category-edit-label")}
                        aria-label={t("expense-category-edit-label")}
                        onClick={() => {
                          setAddEditExpenseCategoryId(rowData.id);
                          setAddEditDrawerShow(true);
                        }}
                        size="large">
                        <EditIcon />
                      </IconButton>
                    </RoleBasedGuard>
                    <RoleBasedGuard
                      resource={RESOURCE.EXPENSECATEGORY}
                      action={ACTION.DELETE}
                    >
                      <IconButton
                        color="secondary"
                        title={t("expense-category-delete-label")}
                        aria-label={t("expense-category-delete-label")}
                        onClick={() => {
                          setDeleteExpenseCategoryId(rowData.id);
                          setDeleteModalShow(true);
                        }}
                        size="large">
                        <DeleteIcon />
                      </IconButton>
                    </RoleBasedGuard>
                  </Fragment>
                ),
              },
            ]}
            data={expenseCategoryDataList?.map((item, index) => {
              return {
                name: item.name,
                id: item.id,
                description: item.description,
              };
            })}
            options={{
              paging: true,
              pageSize: 10,
              emptyRowsWhenPaging: false, //to make page size fix in case of less data rows
              pageSizeOptions: [10, 20, 30],
              sorting: true,
              selection: CheckPermission(RESOURCE.EXPENSECATEGORY, ACTION.DELETE) ? true : false,
              actionsColumnIndex: -1,
              searchFieldAlignment: "left",
              searchFieldStyle: { color: theme.palette.grey[500] },
              headerStyle: {
                color: theme.palette.grey[600],
                backgroundColor: theme.palette.grey[200],
              },
              // rowStyle: (rowData, index) => {
              //   if (index % 2) {
              //     return { backgroundColor: "#f2f2f2" };
              //   }
              // },
            }}
            actions={
              CheckPermission(RESOURCE.EXPENSECATEGORY, ACTION.DELETE) ? [
                {
                  icon: () => <DeleteForever />,
                  tooltip: "Delete Rows",
                  onClick: handleDeleteRowsConformation
                }
              ] : []
            }
            localization={{
              toolbar: {
                searchPlaceholder: t("search"),
              },
              body: {
                emptyDataSourceMessage: expenseCategoryLoader ? (
                  <SkeletonLoader />
                ) : (
                  <NotFoundComponent imgUrl={noFoundImg}>
                    <p style={{ fontWeight: 600 }}>
                      {t("expense-category-empty-data-message")}
                    </p>
                  </NotFoundComponent>
                ),
              },
            }}
            // other props
            components={{
              Toolbar: (props) => (
                <div className="custom-material-table-toolbar ">
                  <MTableToolbar {...props} />
                  <div style={{ padding: "0px 10px" }}>
                    <RoleBasedGuard
                      resource={RESOURCE.EXPENSECATEGORY}
                      action={ACTION.ADD}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        // onClick={addEditModelToggle}
                        startIcon={<AddCircleOutlineIcon />}
                        style={{ background: "", color: "#fff" }}
                        onClick={() => {
                          setAddEditDrawerShow(true);
                        }}
                      >
                        {t("expense-category-add-label")}
                      </Button>
                    </RoleBasedGuard>
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </DeskTopContainer>
      <MobileContainer>
        <div className={classes.mobileCard}>
          <MobileTitle
            resource={RESOURCE.EXPENSECATEGORY}
            title={t("expense-category-label")}
            addButton={addDrawerShow}
          />
          <SearchBarInput
            onChange={(e) => {
              setSearchExpenseCategory(e.target.value);
            }}
            value={searchExpenseCategory}
            placeholder={t("expense-category-search-label")}
            clearTxt={clearTxt}
          />
          {expenseCategoryLoader ? (
            <SkeletonLoader count={3} height="10rem" />
          ) : (
            <div className={classes.mobileCategoryCard}>
              {filterExpenseCategoryList &&
                filterExpenseCategoryList.map((item, index) => (
                  <MobileCategory
                    resource={RESOURCE.EXPENSECATEGORY}
                    name={item.name}
                    active={item.is_active}
                    deleteData={deleteData}
                    editData={editData}
                    itemId={item?.id}
                    isMenuBar
                  />
                ))}
            </div>
          )}
        </div>
        {filterExpenseCategoryList?.length < 1 && !expenseCategoryLoader && (
          <NotFoundComponent imgUrl={noFoundImg}>
            <p style={{ fontWeight: 600 }}>
              {t("expense-category-empty-data-message")}
            </p>
          </NotFoundComponent>
        )}
      </MobileContainer>
      <PopUpModel
        show={deleteModalShow}
        heading={t("expense-category-delete-popup-title")}
        body={t("expense-category-delete-popup-body")}
        footer={
          <>
            <Button
              variant="contained"
              color="primary"
              className="mr-3"
              onClick={() => setDeleteModalShow(false)}
            >
              {" "}
              <Cancel /> {t("popup-cancel-button-label")}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => deleteFoodCategoryData(deleteExpenseCategoryId)}
            >
              {" "}
              <Delete />{" "}
              {deletingBtnProcess ? <CircularProgress /> : t("delete")}{" "}
            </Button>
          </>
        }
        onHide={() => setDeleteModalShow(false)}
      />
      <PopUpModel
        show={deletebulkPopupshow}
        heading={"Are you sure you want to delete selected expense Category?"}
        body={"Please Conform Selected Opration."}
        footer={
          <>
            <Button
              variant="contained"
              color="primary"
              className="mr-3"
              onClick={() => setDeletebulkPopupshow(false)}
            >
              {" "}
              <Cancel /> {t("popup-cancel-button-label")}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleDeleteRows}
            >
              {" "}
              <Delete /> {t("delete")}{" "}
            </Button>
          </>
        }
        onHide={() => setDeletebulkPopupshow(false)}
      />
      <TemporaryDrawer
        drawerClose={addEditDrawerClose}
        isOpen={addEditDrawerShow}
        drawerWidth="50%"
        icon={<Category />}
        title={t("expense-category-title")}
      >
        <AddEditExpenseCategory
          category_id={addEditExpenseCategoryId}
          drawerClose={addEditDrawerClose}
        />
      </TemporaryDrawer>
    </Root>
  );
};

export default ExpenseCategoryList;
